export default function DefaultFooter() {
  return (
    <footer className="default-footer">
      <div className="default-footer-content">
        <div className="default-footer-main">
          <div className="default-footer-section">
            <h3>Про фонд</h3>
            <div className="default-footer-details">
              <p><strong>Благодійна організація "жмут щастя"</strong></p>
              <p>ЄДРПОУ: 12345678</p>
              <p>м. Київ, вул. Тварини, 15</p>
              <p>info@zmutiloshcha.org</p>
            </div>
          </div>
          <div className="default-footer-section">
            <h3>Реквізити для пожертв</h3>
            <div className="default-bank-details">
              <div className="default-bank-row">
                <span className="default-bank-label">Банк</span>
                <span className="default-bank-value">ПриватБанк</span>
              </div>
              <div className="default-bank-row">
                <span className="default-bank-label">IBAN</span>
                <span className="default-bank-value">UA123456789012345678901234567</span>
              </div>
              <div className="default-bank-row">
                <span className="default-bank-label">SWIFT</span>
                <span className="default-bank-value">PBANUA2X</span>
              </div>
              <div className="default-bank-row">
                <span className="default-bank-label">Отримувач</span>
                <span className="default-bank-value">БО "жмут щастя"</span>
              </div>
            </div>
          </div>
        </div>
        <div className="default-footer-bottom">
          <p className="default-copyright">© 2024 жмут щастя. Всі права захищені.</p>
          <div className="default-footer-links">
            <a href="#">Статут</a>
            <a href="#">Звітність</a>
            <a href="#">Політика конфіденційності</a>
          </div>
          <div className="default-footer-social">
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
